export default __webpack_public_path__ + "static/media/social-instagram.564fb194.svg";